import type {
  FilterCheckbox,
  FilterChoice,
  FilterRange,
  FilterSelect,
  FilterValue,
} from './types';

export const isFilterCheckbox = (value: FilterValue):
value is FilterCheckbox => value.type === 'checkbox';

export const isFilterChoice = (value: FilterValue):
value is FilterChoice => value.type === 'choice';

export const isFilterRange = (value: FilterValue):
value is FilterRange => value.type === 'range';

export const isFilterSelect = (value: FilterValue):
value is FilterSelect => value.type === 'select';
